var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 2.33398H4.66634C2.66634 2.33398 1.33301 3.33398 1.33301 5.66732V10.334C1.33301 12.6673 2.66634 13.6673 4.66634 13.6673H11.333C13.333 13.6673 14.6663 12.6673 14.6663 10.334V5.66732C14.6663 3.33398 13.333 2.33398 11.333 2.33398ZM11.6463 6.39398L9.55967 8.06065C9.11967 8.41398 8.55967 8.58732 7.99967 8.58732C7.43967 8.58732 6.87301 8.41398 6.43967 8.06065L4.35301 6.39398C4.13967 6.22065 4.10634 5.90065 4.27301 5.68732C4.44634 5.47398 4.75967 5.43398 4.97301 5.60732L7.05967 7.27398C7.56634 7.68065 8.42634 7.68065 8.93301 7.27398L11.0197 5.60732C11.233 5.43398 11.553 5.46732 11.7197 5.68732C11.893 5.90065 11.8597 6.22065 11.6463 6.39398Z",
    fill: "#312F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.782fd2f93e682480afa49d9cda8afa37.svg";
export { ForwardRef as ReactComponent };